<template>
  <v-layout row wrap>
    <v-flex xs12 sm5 md4>
      <v-card>
        <v-list>
          <v-list-item v-for="header in headers" :key="header" :href="getEditLink(header)">
              <v-list-item-content>
                <v-list-item-title v-if="header === $route.params.level1"><b>{{ header | capitalize }}</b></v-list-item-title>
                <v-list-item-title v-else>{{ header | capitalize }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </v-list>
      </v-card>
    </v-flex>
    <v-flex xs12 sm7 md8>
      <v-card style="min-height: 20px">
        <isrs-i18n-dialog v-bind="{languages, getText, getDefault, onSave, texts}" :is-multiline="$route.params.level1 === 'text'"/>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import objectPath from 'object-path';
import { mapState, mapGetters, mapActions } from 'vuex'
import IsrsI18nDialog from '../components/IsrsI18nDialog.vue'

export default {
  props: {
    baseUrl: {
      type: String,
      required: true
    },
    texts: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  components: {
    IsrsI18nDialog
  },
  data() {
    return {
      headers: ['subject', 'text'],
        languages: {
          en: 'English',
          de: 'German',
          da: 'Danish',
          pl: 'Polish',
          nl: 'Dutch',
          nl_be: 'Dutch (BE)',
          fr: 'French',
          fr_be: 'Français (BE)',
          hu: 'Magyar',
        }
    }
  },
  computed: {
    ...mapState('texts', ['i18nextMail']),
    selectedKey() {
      return this.$route.params.app
    }
  },
  methods: {
    getText(lang) {
      if(this.texts[lang] && this.texts[lang][this.$route.params.level1]) {
        return this.texts[lang][this.$route.params.level1]
      }
      return this.getDefault(lang)
    },
    getDefault(lang) {
      return this.i18nextMail[lang]['translation'][this.$route.params.level1]
    },
    getEditLink(header) {
      return `#${this.baseUrl}/texts/mail/${header}`
    },
    onSave(data) {
      let texts = this.texts;

      Object.keys(this.languages)
        .map(key => [
          key,
          data[key],
          this.getText(key)
        ]).forEach( ([key, newVal, oldVal]) => {
          if(newVal) {
            objectPath.set(this.texts, `${key}.${this.$route.params.level1}`, newVal);
          }
        })

      this.$emit('saveMailTexts', this.texts)
    }
  }
}
</script>



// WEBPACK FOOTER //
// IsrsMailTextsDialog.vue?ec51c926